import {
    Box,
    Typography,
    TextField,
    Select,
    MenuItem,
    Button,
    IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { useEffect, useState, useMemo } from "react";
import { Get_URI } from "./config";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import { language } from "../../Utils/Language";
// API call to get items with filters
import { toast } from "react-toastify";
import AddStockDialog from "../../Components/Dialogs/AddStock";
import InvoicePage from "./InvoiceDetails";
import { useSearchParams } from "react-router-dom";
const AddInvoice = ({
    initialInvoiceData = null,
    isEditMode = false,
    editInvoiceId = null,
}) => {
    const words = language();
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState(""); // Added state for filtering
    const [isAddStockDialogOpen, setIsAddStockDialogOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isRefresh, setIsRefresh] = useState(false);
    const [searchParams] = useSearchParams();

    const authHeader = useAuthHeader();

    // Memoize the params to ensure useEffect re-runs when URL changes
    const paramsKey = useMemo(
        () => ({
            invoiceType: searchParams.get("invoiceType"),
            customerId: searchParams.get("selectedCustomer"),
        }),
        [searchParams]
    );

    const [invoice, setInvoice] = useState(
        isEditMode && initialInvoiceData
            ? {
                  otherPartyId: initialInvoiceData.otherPartyId,
                  taxPercentage: initialInvoiceData.taxPercentage || 0,
                  dollarToLiraRate:
                      initialInvoiceData.dollarToLiraRate || 89500,
                  note: initialInvoiceData.note || "",
                  items: initialInvoiceData.items || [],
                  serialId: initialInvoiceData.serialId || null, // Preserve serialId in edit mode
              }
            : {
                  otherPartyId: 0,
                  taxPercentage: 0,
                  dollarToLiraRate: 89500,
                  note: "",
                  items: [],
                  serialId: null,
              }
    );
    const handleAddInvoice = async () => {
        setConfirmedSale(true);
    };
    // {
    //     "id": 1,
    //     "quantity": 1,
    //     "price": 300,
    //     "discountAmount": 0,
    //     "discountPercentage": 0
    // }
    const [otherParties, setOtherParties] = useState([]);
    const [stockLocations, setStockLocations] = useState([]);

    // Default Add: if item already in invoice, increment its quantity, otherwise add new line
    const addItemToInvoice = (id) => {
        var _invoice = { ...invoice };
        var _items = items;

        // index of the item in the invoice
        var index = _invoice.items.findIndex((_item) => _item.id === id);

        // index of the item in the item list
        var index2 = _items.findIndex((_item) => _item.id === id);

        // if item exists in invoice, increment quantity
        if (index !== -1) {
            _invoice.items[index].quantity++;
            if (index2 !== -1) {
                _items[index2].remaining--;
            }
            setItems(_items);
            setInvoice(_invoice);
            return;
        }

        // otherwise add as a new line
        _invoice.items = [
            ..._invoice.items,
            {
                id: id,
                name: items[index2]?.name,
                quantity: 1,
                price: items[index2]?.priceNormal,
                discountAmount: 0,
                discountPercentage: 0,
                isTaxable: false,
                lineId: `${id}-${Date.now()}-${Math.floor(
                    Math.random() * 1000
                )}`,
            },
        ];

        if (index2 === -1) {
            return;
        }
        _items[index2].remaining--;
        setItems(_items);
        setInvoice(_invoice);
    };

    // Add As Different: always add a new line item even if same product exists in invoice
    const addItemAsDifferent = (id) => {
        var _invoice = { ...invoice };
        var _items = items;

        // index of the item in the item list
        var index2 = _items.findIndex((_item) => _item.id === id);

        // Always add as a new line item
        _invoice.items = [
            ..._invoice.items,
            {
                id: id,
                name: items[index2]?.name,
                quantity: 1,
                price: items[index2]?.priceNormal,
                discountAmount: 0,
                discountPercentage: 0,
                isTaxable: false,
                lineId: `${id}-${Date.now()}-${Math.floor(
                    Math.random() * 1000
                )}`,
            },
        ];

        if (index2 === -1) {
            return;
        }
        _items[index2].remaining--;
        setItems(_items);
        setInvoice(_invoice);
    };
    const removeItemFromInvoice = (itemIndex) => {
        var _invoice = { ...invoice };
        var _items = items;

        // Get the item being removed
        const itemToRemove = _invoice.items[itemIndex];

        // Remove the specific line item from invoice
        _invoice.items = _invoice.items.filter(
            (_, index) => index !== itemIndex
        );

        // Find the item in the stock list and increment remaining
        var index2 = _items.findIndex((_item) => _item.id === itemToRemove.id);
        if (index2 !== -1) {
            _items[index2].remaining++;
            setItems(_items);
        }

        setInvoice(_invoice);
        // toast("invoice item removed");
    };
    const handleInvoiceChange = (event) => {
        const { name, value } = event.target;
        setInvoice({ ...invoice, [name]: value });
    };
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [confirmedSale, setConfirmedSale] = useState(false);

    useEffect(() => {
        const getOtherParities = async () => {
            try {
                const response = await fetch(Get_URI("GET_CUSTOMERS"), {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authHeader,
                    },
                });
                if (response.ok) {
                    const responseData = await response.json();
                    setStockLocations(responseData.stockLocations);
                    setOtherParties(responseData.otherParties);
                } else {
                    throw new Error("Network response was not ok");
                }
            } catch (err) {
                toast.error("Something went wrong getting otherParties");
            }
        };
        const getItems = async () => {
            // Determine if we should force isHidden true (edit mode, hidden invoice)
            let isHiddenParam = searchParams.get("invoiceType") === "3";
            if (isEditMode && initialInvoiceData?.typeId === 3) {
                isHiddenParam = true;
            }
            try {
                const response = await fetch(
                    Get_URI("GET_ITEMS") +
                        "?" +
                        new URLSearchParams({
                            isHidden: isHiddenParam,
                            customerId: searchParams.get("selectedCustomer"),
                        }),
                    {
                        method: "GET",

                        headers: {
                            "Content-Type": "application/json",
                            Authorization: authHeader,
                        },
                    }
                );
                if (response.ok) {
                    const responseData = await response.json();
                    const dataWithRemaining = responseData.data.map((item) => {
                        const remaining = item.Stock.reduce(
                            (sum, item) => sum + item.quantityRemaining,
                            0
                        );

                        let priceFromSpecial = item.price;
                        console.log(item?.SpecialPricing);
                        const specialPrice = item?.SpecialPricing?.find(
                            ({ otherPartyId }) =>
                                otherPartyId ===
                                Number(searchParams.get("selectedCustomer"))
                        );
                        if (specialPrice) {
                            priceFromSpecial = Number(specialPrice.price);
                        }

                        return {
                            ...item,
                            remaining,
                            priceNormal: priceFromSpecial || item.priceNormal,
                        };
                    });
                    setItems(dataWithRemaining);
                } else {
                    throw new Error("Network response was not ok");
                }
            } catch (err) {
                console.log(err);
                toast.error("Something went wrong getting items");
            }
        };

        getItems();
        getOtherParities();
    }, [authHeader, isRefresh, paramsKey]);

    var filterParams = (item) => {
        return item.name.toLowerCase().includes(filter.toLowerCase());
    };
    useEffect(() => {
        setInvoiceItems(invoice.items);
    }, [confirmedSale, invoice.items]);

    if (confirmedSale) {
        return (
            <InvoicePage
                items={invoiceItems}
                setItems={setInvoiceItems}
                otherPartyId={searchParams.get("selectedCustomer")}
                authHeader={authHeader}
                invoice={invoice}
                typeId={searchParams.get("invoiceType")}
                isEditMode={isEditMode}
                editInvoiceId={editInvoiceId}
            />
        );
    }
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100vh",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    flex: 1,
                    minHeight: 0,
                    overflow: "hidden",
                }}
            >
                {/* left Box */}
                <Box
                    sx={{
                        flex: 1,
                        padding: 2,
                        borderRight: 1,
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                    }}
                >
                    <Typography>{words["INVOICE"]}</Typography>

                    {searchParams.get("invoiceType") === "1" && (
                        <>
                            <TextField
                                name="taxPercentage"
                                size="small"
                                label={words["TAX_PERCENTAGE"]}
                                onChange={handleInvoiceChange}
                                type="number"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                            />
                            <TextField
                                name="dollarToLiraRate"
                                size="small"
                                label={
                                    words["EXCHANGE_RATE"] ||
                                    "Exchange Rate (USD to LBP)"
                                }
                                onChange={handleInvoiceChange}
                                type="number"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                value={invoice.dollarToLiraRate || ""}
                                placeholder="e.g., 89500"
                            />
                        </>
                    )}
                    <TextField
                        name="note"
                        size="small"
                        label={words["NOTE"]}
                        onChange={handleInvoiceChange}
                        type="text"
                        variant="outlined"
                        margin="dense"
                        fullWidth
                    />
                    {/*
                     */}

                    <Typography>{words["ITEM_LIST"]}</Typography>
                    <Box
                        sx={{
                            overflowY: "auto",
                            overflowX: "hidden",
                            padding: 3,
                            flex: 1,
                            minHeight: 0,
                        }}
                    >
                        {invoice.items.length > 0 &&
                            invoice.items.map((invoiceItem, index) => (
                                <Box
                                    key={`${invoiceItem.id}-${index}`}
                                    sx={{
                                        display: "flex",
                                        borderRadius: 1,
                                        padding: 1,
                                        marginBottom: 2,
                                        flexDirection: "row",
                                        boxShadow: "3px 3px 10px 1px #ababab",
                                        backgroundColor: "primary.main",
                                    }}
                                >
                                    <Box
                                        key={invoiceItem.id}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <Typography
                                            marginRight={1}
                                            width={50}
                                        >{`${invoiceItem.quantity}`}</Typography>
                                        <Typography
                                            marginRight={1}
                                            sx={{ borderRight: 1 }}
                                        ></Typography>
                                        <Typography marginRight={1}>
                                            {invoiceItem.name}
                                        </Typography>
                                        <Typography
                                            marginRight={1}
                                            sx={{ borderRight: 1 }}
                                        ></Typography>
                                        <Typography marginRight={1}>
                                            ${invoiceItem.price}
                                        </Typography>
                                        <Typography
                                            marginRight={1}
                                            sx={{ borderRight: 1 }}
                                        ></Typography>
                                    </Box>
                                    <IconButton
                                        title={words["ADD_TO_INVOICE"]}
                                        color="primary"
                                        sx={{
                                            px: 1,
                                            minWidth: 0,
                                            marginRight: 1,
                                            fontSize: "0.8rem",
                                            "& .MuiSvgIcon-root": {
                                                fontSize: 14,
                                            },
                                            backgroundColor: "white",
                                            "&:hover": {
                                                backgroundColor: "white",
                                            },
                                        }}
                                        onClick={() =>
                                            addItemToInvoice(invoiceItem.id)
                                        }
                                    >
                                        <AddIcon />
                                    </IconButton>
                                    <IconButton
                                        title={words["ADD_TO_INVOICE"]}
                                        color="error"
                                        sx={{
                                            px: 1,
                                            minWidth: 0,
                                            marginRight: 1,
                                            fontSize: "0.8rem",
                                            "& .MuiSvgIcon-root": {
                                                fontSize: 14,
                                            },
                                            backgroundColor: "white",
                                            "&:hover": {
                                                backgroundColor: "white",
                                            },
                                        }}
                                        onClick={() =>
                                            removeItemFromInvoice(index)
                                        }
                                    >
                                        <RemoveIcon />
                                    </IconButton>
                                </Box>
                            ))}
                    </Box>
                </Box>

                {/* Right Box */}

                <Box
                    sx={{
                        flex: 1,
                        padding: 2,
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                    }}
                >
                    <Typography>{words["STOCK"]}</Typography>
                    <Box sx={{ marginBottom: 2 }}>
                        <TextField
                            size="small"
                            label={words["FILTER"]}
                            onChange={(e) => setFilter(e.target.value)}
                            type="text"
                            variant="outlined"
                            margin="dense"
                            fullWidth
                        />
                    </Box>
                    <Box
                        sx={{
                            overflowY: "auto",
                            overflowX: "hidden",
                            padding: 3,
                            flex: 1,
                            minHeight: 0,
                        }}
                    >
                        {items.length > 0 &&
                            items.filter(filterParams).map((item) => (
                                <Box
                                    key={item.id}
                                    sx={{
                                        display: "flex",
                                        padding: 1,
                                        borderRadius: 1,
                                        marginBottom: 2,
                                        flexDirection: "row",
                                        boxShadow: "3px 3px 10px 1px #ababab",
                                        cursor: "pointer",
                                        backgroundColor:
                                            item.remaining <=
                                            item.minAlarmQuantity
                                                ? "secondary.main"
                                                : "primary.main",
                                    }}
                                >
                                    <Box
                                        onClick={() =>
                                            addItemToInvoice(item.id)
                                        }
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                        }}
                                    >
                                        <Typography
                                            marginRight={1}
                                            width={25}
                                        >{`${item.remaining}`}</Typography>
                                        <Typography
                                            marginRight={1}
                                            sx={{ borderRight: 1 }}
                                        ></Typography>
                                        <Box
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="start"
                                        >
                                            <Typography
                                                marginRight={1}
                                                width={200}
                                            >
                                                {item.name}
                                            </Typography>
                                            <Typography
                                                marginRight={1}
                                                width={200}
                                                variant="caption"
                                            >
                                                {item.description}
                                            </Typography>
                                        </Box>
                                        <Typography
                                            marginRight={1}
                                            sx={{ borderRight: 1 }}
                                        ></Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                        }}
                                    >
                                        <IconButton
                                            title="Add as Different"
                                            color="primary"
                                            sx={{
                                                px: 1,
                                                minWidth: 0,
                                                fontSize: "0.8rem",
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: 14,
                                                },
                                                backgroundColor: "white",
                                                "&:hover": {
                                                    backgroundColor: "white",
                                                },
                                            }}
                                            onClick={() =>
                                                addItemAsDifferent(item.id)
                                            }
                                        >
                                            <PlaylistAddIcon />
                                        </IconButton>

                                        <IconButton
                                            title="Add Stock"
                                            color="primary"
                                            sx={{
                                                px: 1,
                                                minWidth: 0,
                                                fontSize: "0.8rem",
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: 14,
                                                },
                                                backgroundColor: "white",
                                                "&:hover": {
                                                    backgroundColor: "white",
                                                },
                                            }}
                                            onClick={() => {
                                                setIsAddStockDialogOpen(true);
                                                setSelectedItem(item);
                                            }}
                                        >
                                            <AddIcon />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))}
                    </Box>
                </Box>
                {isAddStockDialogOpen && (
                    <AddStockDialog
                        item={selectedItem}
                        isOpen={isAddStockDialogOpen}
                        stockLocations={stockLocations}
                        onClose={() => {
                            setIsAddStockDialogOpen(false);
                            setSelectedItem(null);
                            setIsRefresh(!isRefresh);
                        }}
                        authHeader={authHeader}
                        otherParties={otherParties}
                    />
                )}
            </Box>

            <Box sx={{ width: "100%", padding: 2, borderTop: 1 }}>
                <Button
                    onClick={handleAddInvoice}
                    variant="contained"
                    fullWidth
                >
                    CreateInvoice
                </Button>
            </Box>
        </Box>
    );
};
export default AddInvoice;
